export type Env = "local" | "dev" | "stg" | "prd";

import { AskQuestionV1Result } from "@/pages/hendren/api";

export type ChatUser = "user" | "maite";

export type MaiteChatMessage =
  | {
      id?: string;
      chatId?: string;
      user: "maite";
      isError: true;
      error?: string;
      debug?: any;
      isScenariosQuery: boolean;
    }
  | {
      id: string;
      chatId: string;
      user: "maite";
      isError: false;
      content: AskQuestionV1Result["content"];
      feedbackScore?: AnswerFeedbackScore | undefined;
      debug?: any;
      isScenariosQuery: boolean;
    };

export type ChatMessage =
  | {
      user: "user";
      content: string;
    }
  | MaiteChatMessage;

export type ChatContextState = {
  pendingQuestion?: string | undefined;
};

export type AnswerFeedbackScore = "positive" | "negative";

export enum ModelDescriptions {
  CLAUDE = "More inquisitive. Better for deep diving into complex queries and per product/channel analysis.",
  GEMINI = "More direct. Better for high-level queries about overall performance.",
}
